import { MapPin, Clock, ExternalLink, Church, Landmark, Navigation } from "lucide-react";
import { Reveal, SectionHeading } from "./common";
import { VISIT } from "../data/content";

const INFO = [
  { icon: MapPin, label: "Località", value: VISIT.place },
  { icon: Navigation, label: "Indirizzo", value: VISIT.address },
  { icon: Clock, label: "Orari", value: VISIT.hours },
];

const RECOGNITIONS = [
  { icon: Landmark, text: "Monumento nazionale dal 1870" },
  { icon: Church, text: "Basilica minore dal 1992" },
  { icon: Church, text: "Officiata dai Frati Minori Francescani" },
];

export const Oggi = () => (
  <section id="oggi" className="relative bg-espresso py-24 sm:py-32 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-3xl">
        <SectionHeading
          eyebrow="Capitolo V"
          title="La Basilica Oggi"
          dark
          testid="section-oggi-title"
        />
        <Reveal delay={0.15}>
          <p className="mt-8 text-base sm:text-lg text-ivory/75 leading-relaxed">
            Oggi Santa Caterina d'Alessandria è insieme{" "}
            <strong className="text-ivory font-semibold">monumento storico</strong>,{" "}
            <strong className="text-ivory font-semibold">capolavoro d'arte</strong> e{" "}
            <strong className="text-ivory font-semibold">luogo di culto attivo</strong>:
            una chiesa viva, visitabile, al centro dell'identità di Galatina.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid sm:grid-cols-3 gap-4">
        {RECOGNITIONS.map(({ icon: Icon, text }, i) => (
          <Reveal key={text} delay={i * 0.08}>
            <div className="flex items-center gap-4 bg-mocha border border-gold/20 px-6 py-5">
              <Icon size={22} strokeWidth={1.5} className="text-goldlight flex-shrink-0" />
              <span className="text-sm sm:text-base text-ivory/85">{text}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-14 grid lg:grid-cols-2 gap-10 items-stretch">
        <div className="flex flex-col gap-4">
          {INFO.map(({ icon: Icon, label, value }, i) => (
            <Reveal key={label} delay={i * 0.08}>
              <div className="flex items-start gap-5 border-b border-ivory/10 pb-5">
                <Icon size={20} strokeWidth={1.6} className="text-goldlight mt-1 flex-shrink-0" />
                <div>
                  <span className="font-mono text-xs tracking-[0.2em] uppercase text-gold">
                    {label}
                  </span>
                  <p className="mt-1 text-base sm:text-lg text-ivory/90">{value}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <div className="flex flex-wrap gap-3 pt-4">
              <a
                href={VISIT.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="maps-link"
                className="inline-flex items-center gap-2 bg-gold text-ink font-semibold text-sm tracking-wide uppercase px-6 py-3.5 rounded-full hover:bg-goldlight transition-colors duration-300"
              >
                <MapPin size={16} />
                Apri la mappa
              </a>
              <a
                href={VISIT.officialUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="official-site-link"
                className="inline-flex items-center gap-2 border border-gold/50 text-goldlight font-medium text-sm tracking-wide uppercase px-6 py-3.5 rounded-full hover:bg-gold/10 transition-colors duration-300"
              >
                <ExternalLink size={16} />
                Sito ufficiale
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="min-h-[320px]">
          <div className="relative h-full min-h-[320px] border border-gold/25 overflow-hidden">
            <iframe
              title="Mappa della Basilica di Santa Caterina d'Alessandria, Galatina"
              src={VISIT.osmEmbed}
              className="absolute inset-0 w-full h-full grayscale-[35%] contrast-[1.05]"
              loading="lazy"
              data-testid="visit-map"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
